<script setup lang="ts">
    export interface IntroProps {
        title?: string;
        description?: string;
        center?: boolean;
        anchor?: string | undefined;
    }
    const props = defineProps<IntroProps>();

    const { setHeader } = useMicroDataStore();
    setHeader({
        name: props.title || '',
        description: removeWoomTextFormat(props.description),
    });
</script>
<template>
    <atm-grid class="mol-intro py-8 md:py-10">
        <div
            :id="anchor"
            :class="[{ 'text-center': center }, 'col-span-2 flex flex-col gap-6 md:col-span-12 lg:col-span-8 lg:col-start-3']">
            <lazy-atm-heading
                v-if="title"
                level="h2"
                size="xl">
                <renderer-html :content="woomTextFormat(title)" />
            </lazy-atm-heading>
            <div
                v-if="description"
                class="link-underline text-lg">
                <renderer-html :content="woomTextFormat(description)" />
            </div>
            <slot></slot>
        </div>
    </atm-grid>
</template>

<style scoped>
    :deep(.link-underline a) {
        @apply underline;
    }
</style>
